module.exports = __webpack_public_path__ + "img/icon_task_flow.73eaed4b.png";